import i18n from "../i18n/i18n";

export function validateTransferInput({
  toUserEmail,
  amount,
  fromWalletId,
  balance,
  fromUserId,
}) {
  const missingFields = [];

  if (!toUserEmail?.trim()) missingFields.push("To user email");
  if (!amount) missingFields.push("Amount");

  if (missingFields.length > 0) {
    return i18n.t("errors.pleaseFillFields", "Please fill in all required fields.");
  }

  if (Number(amount) <= 0) {
    return i18n.t("errors.amountGreaterThanZero", "Amount must be greater than zero.");
  }

  if (balance === 0 || balance < Number(amount)) {
    return i18n.t("errors.insufficientBalance", "Insufficient balance for this transfer.");
  }

  if (toUserEmail.trim().toLowerCase() === fromUserId?.toLowerCase()) {
    return i18n.t("errors.cannotTransferToSelf", "You cannot transfer funds to yourself.");
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(toUserEmail)) {
    return i18n.t("errors.pleaseEnterValidEmail", "Please enter a valid email address.");
  }

  return null;
}

export function parseTransferError(error) {
  const status = error?.status || error?.response?.status;
  const detail = error?.message || error?.response?.data?.detail || error?.response?.data?.error || "Transfer failed.";

  if (typeof detail === "string") {
    if (detail.toLowerCase().includes("insufficient")) {
      return i18n.t("errors.insufficientBalance", "Insufficient balance for this transfer.");
    }
    if (detail.toLowerCase().includes("invalid user") || detail.toLowerCase().includes("not found")) {
      return i18n.t("errors.recipientNotFound", "Recipient user not found or invalid email.");
    }
    if (detail.toLowerCase().includes("same user") || detail.toLowerCase().includes("self")) {
      return i18n.t("errors.cannotTransferToSelf", "You cannot transfer funds to yourself.");
    }
  }

  switch (status) {
    case 400:
      return i18n.t("errors.invalidWalletOrAmount", "Invalid wallet ID or amount. Please check your input.");
    case 401:
      return i18n.t("errors.sessionExpired", "Your session has expired. Please sign in again.");
    case 403:
      return i18n.t("errors.notAuthorizedTransfer", "You are not authorized to perform this transfer.");
    case 404:
      return i18n.t("errors.walletNotFound", "Wallet not found. Please check the wallet ID.");
    case 422:
      return i18n.t("errors.dataValidationFailed", "Data validation failed. Please check your input.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Service is temporarily unavailable. Please try again in a moment.");
    default:
      return i18n.t("errors.transferFailed", "Transfer failed. Please try again or contact support.");
  }
}
